import { render, staticRenderFns } from "./WorkDialog.vue?vue&type=template&id=88b70e00&scoped=true&"
import script from "./WorkDialog.vue?vue&type=script&lang=js&"
export * from "./WorkDialog.vue?vue&type=script&lang=js&"
import style0 from "./WorkDialog.vue?vue&type=style&index=0&id=88b70e00&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88b70e00",
  null
  
)

export default component.exports